export default {
  'itemDetail.purchasedThisItem': '購買了此商品',
  'itemDetail.ProductDetailsPageSKUSelectionDrawer': '商品詳情頁_SKU選擇抽屜',
  'itemDetail.ProductDetailsPageSKUSelectionDrawerselectProducts':
    '商品詳情頁_SKU選擇抽屜_選擇商品',
  'itemDetail.ProductDetailsPageSKUSelectionDrawerOKButton': '商品詳情頁_SKU選擇抽屜_確定按鈕',
  'itemDetail.ProductDetailsPageSKUSelectionDrawerChooseSubscriptionMode':
    '商品詳情頁_SKU選擇抽屜_選擇訂閱模式',
  'itemDetail.FailedToCollectCouponPleaseTryAgainLater': '領券失敗，請稍後再試',
  'itemDetail.hasBeenRemoved': '已下架',
  'itemDetail.NoAppointmentsYet': '暫無預約資格',
  'itemDetail.AppointmentSuccessfulViewDetails': '預約成功，查看詳情',
  'itemDetail.willBe': '將於',
  'itemDetail.OnSale': '開售',
  'itemDetail.AppointmentSuccessful': '預約成功',
  'itemDetail.AppointmentFailed': '預約失敗',
  'itemDetail.bookNow': '立即預約',
  'itemDetail.have': '已有',
  'itemDetail.TheAppointmentWasSuccessful': '人預約成功',
  'itemDetail.AppointmentNotStarted': '預約未開始',
  'itemDetail.startAnAppointment': '開始預約',
  'itemDetail.hasNotStarted': '未開始',
  'itemDetail.over': '已結束',
  'itemDetail.robbed': '已搶',
  'itemDetail.remaining': '剩餘',
  'itemDetail.ProductDetailsPagebuyButton': '商品詳情頁_購買按鈕',
  'itemDetail.BuyNow': '立即購買',
  'itemDetail.TheProductIsARestrictedProductYouCannotPurchaseItIfYouDoNotMeetTheRestrictedPurchaseConditions':
    '商品為限購商品，您不滿足限購條件，無法購買',
  'itemDetail.snapUpNow': '立即搶購',
  'itemDetail.NotEligibleToGet': '暫無資格前往獲取',
  'itemDetail.NotEligibleForRedemption': '暫無兌換資格',
  'itemDetail.SoldOut': '已售罄',
  'itemDetail.ChooseAnItem': '選擇商品',
  'itemDetail.flashSale': '限時搶購',
  'itemDetail.GetItForFree': '免費領取',
  'itemDetail.RedeemNow': '立即兌換',
  'itemDetail.individualShopping': '單獨購買',
  'itemDetail.InitiateAGroupPurchase': '發起團購',
  'itemDetail.PurchaseInInstallments': '分期購買',
  'itemDetail.afterCoupon': '券後',
  'itemDetail.Expect': '期',
  'itemDetail.Minute': '分',
  'itemDetail.day天hourminutesecond': '{day}天 {hour}:{minute}:{second}',
  'itemDetail.onlyLeftToEnd': '距結束僅剩',
  'itemDetail.MMMonthDDDayHHmm': 'MM月DD日HH:mm',
  'itemDetail.Finish': '結束',
  'itemDetail.immediateReduction': '立減',
  'itemDetail.PleaseSelectAnItem': '請選擇商品',
  'itemDetail.InsufficientGrowthBeansGetItNow': '成長豆不足立即獲取',
  'itemDetail.InsufficientBalanceOfGrowthBeans': '成長豆餘額不足',
  'itemDetail.CouponPurchase': '領券購買',
  'itemDetail.Sure': '確定',
  'itemDetail.ChooseHowToBuy': '選擇購買方式',
  'itemDetail.YouHaveAlreadyActivatedThisProductYouCannotChooseToSubscribe':
    '您已激活該商品，不可選擇訂閱',
  'itemDetail.YouAreAlreadySubscribedToThisItem': '您已訂閱該商品',
  'itemDetail.ThisSubscriptionModelIsNotCurrentlySupported': '暫不支持該訂閱模式',
  'itemDetail.oneTimePayment': '一次性支付',
  'itemDetail.specialPrice': '優惠價',
  'itemDetail.LimitedTimeOffer': '限時優惠',
  'itemDetail.ParameterError': '參數錯誤!',
  'itemDetail.share': '分享',
  'itemDetail.subscription': '訂閱',
  'itemDetail.accordingTo': '按',
  'itemDetail.delivery': '送貨',
  'itemDetail.ExpressDelivery': '快遞配送',
  'itemDetail.illustrate': '說明',
  'itemDetail.callOfficial': '叫叫官方',
  'itemDetail.ProductDetailsPageCustomerServiceButton': '商品詳情頁_客服按鈕',
  'itemDetail.customerService': '客服',
  'itemDetail.ActivitiesAndCouponsAreMutuallyExclusiveAndItIsMoreCostEffectiveToRecommendCoupons':
    '活動與優惠券互斥，推薦用券更划算',
  'itemDetail.selected': '已選',
  'itemDetail.HuabeiInstallmentoptional': '花唄分期（可選）',
  'itemDetail.perIssue': '/每期',
  'itemDetail.PurchaseQuantity': '購買數量',
  'itemDetail.goToView': '前往查看',
  'itemDetail.YouHaveParticipatedInTheGroupGroupActivityClickTheButtonBelowToViewTheGroupGroupProgress':
    '您已參加拼團活動,點擊下方按鈕查看拼團進度哦',
  'itemDetail.ProductDetailsPageretainPopUpExposure': '商品詳情頁_挽留 彈窗曝光',
  'itemDetail.mall': '商城',
  'itemDetail.ProductDetailsPageretainPopupContentButtonClick': '商品詳情頁_挽留彈窗內容按鈕點擊',
  'itemDetail.other': '其他',
  'itemDetail.ProductDetailsPageRetainTheButtonClickAtTheBottomOfThePopUpWindow':
    '商品詳情頁_挽留彈窗底部按鈕點擊'
};
